<h2 mat-dialog-title>Value from another control</h2>
<mat-dialog-content>
  <div style="overflow: hidden;">
    Merge value from 
    <tyl-form-field label='Control'>
      <mat-select id='ddlObject' [(ngModel)]='selectedObject'>
        <mat-option *ngFor='let object of objects' [value]='object'>{{object | getDesignerControlName}}</mat-option>
      </mat-select>
    </tyl-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class='flex-footer-left'>

  </div>
  <div class='flex-footer-right'>
    <tyl-button image="save.png" label="Save" (clickEvent)="saveClick()"></tyl-button>
    <tyl-button image="cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
  </div>
</mat-dialog-actions>
